<template>
    <div class="col-md-3 col-sm-6 mb-sm-4 profile-block profile-block--susilive" :id="id">
        <a :href="clickUrl" class="profile-block-link h-100" :target="advert.isDefault ? '_self' : '_blank'" rel="nofollow">
            <span class="profile-block-images loaded h-100">
                <div class="profile-block-images-new-banner susilive-item-partner-tag"
                     v-if="!advert.isDefault && advert.imageurl">Live cam</div>
                <div v-if="!advert.imageurl" class="susilive-item-image"></div>
                <div v-else :style="{'background-image': `url('${advert.imageurl}')`}" class="susilive-item-image"
                     :class="{'susilive-item-image--default': advert.isDefault}"></div>
            </span>
        </a>

        <span class="profile-block-details">
            <span class="user-details overflow-hidden">
                <span class="heading-1 d-flex">
                    <span class="text-ellipsis">
                        {{ advert.name }}
                    </span>
                </span>
                <span class="user-details-location" v-if="!hideExplicitRegionAds">
                    <span class="text-ellipsis text-bold color-teal-base">
                        111 MIN KOSTENLOS
                    </span>
                </span>
            </span>
        </span>
    </div>
</template>

<script>
import xtrackingMixin from "@/components/mixins/xtrackingMixin";
import advertMixin from "@/components/mixins/adverts/advertMixin";
import {pick} from "lodash/object";
import {generateImpressionId} from "@/core/utils/helpers/advertHelper";

/**
 * Add additional get params for the tracking
 * @returns {URL}
 */
function clickUrl() {
    try {
        const url = new URL(this.advert.clickurl);
        url.searchParams.append('action', 'native-ads-click');
        url.searchParams.append('label', 'native-susi-live');
        url.searchParams.append('position', this.advert.position);
        url.searchParams.append('sch', this.advert.searchId);

        return url;
    } catch (e) {
        return regionRelativeUrl('/users/registration');
    }
}

const data = () => {
    return {
        id: generateImpressionId(),
        impressionIds: [],
        impressionId: null,
    }
}

function created() {
    this.impressionId = generateImpressionId();
}

function observer() {
    if (this.hideExplicitRegionAds) {
        return;
    }

    const id = this.id;
    if (!id || typeof window === "undefined" || !_.get(this, 'advert.imageurl', _.get(this, 'advert.image_full_link'))) {
        return;
    }
    const advertisement = document.getElementById(id);
    if (typeof IntersectionObserver !== 'undefined') {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (!this.impressionIds.includes(id)) {
                        this.impressionIds.push(id);
                        const nativeImpressionCount = incrementNativeAdImpressionCount();
                        const extraAttributes = pick(this.advert || {}, ['imageurl', 'name'])
                        this.captureTrackingEvent(this.currentUser, 'search', 'native-ads-impression', 'native-susi-live', null, {
                            position: this.advert.position,
                            sch: this.advert.searchId,
                            'native_impression_count': nativeImpressionCount,
                            'impression_id': this.impressionId,
                            ...extraAttributes,
                        })
                    }
                    observer.disconnect();
                }
            });
        }, {
            threshold: 0.5
        });
        observer.observe(advertisement);
    }
}

export default {
    created,
    data,
    computed: {
        ...mapState(['currentUser', 'hideExplicitRegionAds']),
    },
    props: {
        advert: {
            required: true,
        }
    },
    methods: {
        observer,
    },
    watch: {
        advert: {
            deep: true,
            handler() {
                this.observer()
            }
        },
    },
    mixins: [xtrackingMixin, advertMixin],
}
</script>
